export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => {
    return next => action => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      const { promise, types, throwError, ...rest } = action;
      if (!promise) {
        return next(action);
      }

      const [REQUEST, SUCCESS, FAILURE] = types;
      next({ ...rest, type: REQUEST });
      return promise(client)
        .then(result => next({ ...rest, payload: result, type: SUCCESS }))
        .catch(error => {
          const resp = next({ ...rest, error, type: FAILURE });

          if (throwError) {
            throw error.data || error;
          }

          return resp;
        });
    };
  };
}
